import { PageLocatorMap } from '../types/PageLocatorMap';

export const signInPinVerifyPage = {
  alert: {
    error: 'signin-pin-verify-page.alert.error',
    success: 'signin-pin-verify-page.alert.success',
  },
  footer: {
    root: 'signin-pin-verify-page.footer.root',
  },
  form: {
    h1: 'signin-pin-verify-page.form.heading1',
    h3: 'signin-pin-verify-page.form.heading3',
    pinInput: (position: number): string =>
      `signin-pin-verify-page.form.pin-input-${position}`,
    pinInputError: 'signin-pin-verify-page.form.pin-error',
    resendPinLink: 'signin-pin-verify-page.form.resend-pin-link',
    root: 'signin-pin-verify-page.form.root',
  },
  header: {
    signUpLink: 'signin-pin-verify-page.header.signup-link',
  },
} as const satisfies PageLocatorMap;
